<template>
  <div v-if="accountStore.salesManager">
    <div class="content-container">
      <div v-if="accountStore.salesManager.mainPicture">
        <SingleAvatarStudent
          :picture="accountStore.salesManager.mainPicture.format.big"
          size="184px"
          rounded="false"
        />
      </div>
      <div class="info-container">
        <div class="info">
          <div class="name">{{ accountStore.salesManager.firstName }}
            {{ accountStore.salesManager.lastName }}
            <span>Votre contact commerciale</span>
          </div>
          <p>
            Bonjour {{ accountStore.firstName }},
          </p>
          <p>
            Je suis {{ accountStore.salesManager.firstName }}, votre contact commercial chez {{ $brand.label }}. Je suis
            en charge des besoins commerciaux et de la facturation.
          </p>
          <p>
            N'hésitez pas à me contacter par téléphone ou par mail si vous avez une urgence, je
            vous répondrai au plus vite !
          </p>
        </div>
      </div>
    </div>
    <div class="sub-info">
      <ul>
        <li v-if="accountStore.salesManager.email">
          <i class="fa fa-paper-plane" aria-hidden="true"/>
          <div class="text">
            {{ accountStore.salesManager.email }}
          </div>
          <span class="span">Mon email</span>
        </li>
        <li v-if="accountStore.salesManager.phone">
          <i class="fa fa-phone" aria-hidden="true"/>
          <div class="text">
            {{ $tel(accountStore.salesManager.phone) }}
          </div>
          <span class="span">Mon numéro de téléphone</span>
        </li>
        <li>
          <i class="fa fa-exclamation-circle" aria-hidden="true"/>
          <div class="text">
            01 86 95 02 15
          </div>
          <span class="span">Numéro de garde pour les urgences en soirées et Week-ends</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import SingleAvatarStudent from '@/components/MyStudents/SingleAvatarStudent';
import { mapStores } from 'pinia';
import { useAccountStore } from '@/stores/account';

export default {
  components: {
    SingleAvatarStudent,
  },
  computed: {
    ...mapStores(useAccountStore),
  },
};
</script>
